import DetectBreakpoints from '~utilities/detect-breakpoints';

class RemoveBreaks {
    constructor(element, attribute) {
        this.element = element;
        const breakBreakpoints = this.element.getAttribute(attribute).split(",");
        if(breakBreakpoints.includes(DetectBreakpoints.breakpoint)) {
	        this.element.innerHTML = this.element.innerHTML.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g,' ');
        }
    }
}

export default RemoveBreaks;